/* @ngInject */
export function routeConfig($urlRouterProvider, $locationProvider) {
  $urlRouterProvider.when('/', '/main/dashboard');
  $urlRouterProvider.otherwise('/404');

  $locationProvider.html5Mode(true);
}



// WEBPACK FOOTER //
// ./client/app/app.config.js